/* global ViewController WebView */

let personalInformationPortalWidgetController = new ViewController({
    directory : "views/portal",
    name: "personalInformationPortalWidget",
    title: WebView.tr("portal.personalInformation"),
    route: "personal-information-portal"
}) ;

personalInformationPortalWidgetController.prepareDataOnEnter = async function(){
    let data = {};
    const employeeId = this.api.currentUser.employee_id;
    const reads = await this.apip.db.multiread ({
        hr_employee: { searchFirst: { id : employeeId},
            joins: [
                { otherTable: "res_partner", name: "address", otherField: "id", thisField: "address_id", joins: [
                    { otherTable: "res_country", name: "country", otherField: "id", thisField: "country_id" }
                ] },
                { otherTable: "res_partner_title", name: "title", otherField: "id", thisField: "iz_title_id"}
            ] 
        }
    });

    if (!reads.hr_employee) {
        return data;
    }

    data.iz_family_name = reads.hr_employee.iz_family_name;
    data.iz_first_name = reads.hr_employee.iz_first_name;
    data.iz_birth_name = reads.hr_employee.iz_birth_name;
    data.iz_title_id = reads.hr_employee.title?reads.hr_employee.title.name:"";

    if (reads.hr_employee.address) {
        data.street = reads.hr_employee.address.street;
        data.street2 = reads.hr_employee.address.street2;
        data.zip = reads.hr_employee.address.zip;
        data.city = reads.hr_employee.address.city;
        data.phone = reads.hr_employee.address.phone;
        data.mobile = reads.hr_employee.address.mobile;
        data.email = reads.hr_employee.address.email;
    }
    if (reads.hr_employee.address.country) {
        data.country = reads.hr_employee.address.country.name;
    }
    return data;
};

module.exports = personalInformationPortalWidgetController ; 
